<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <template #activator="{on,attrs}">
      <v-btn class="d-print-none" v-on="on" v-bind="attrs" icon color="success">
        <v-icon>fas fa-hand-holding-usd</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        Debtor Payment
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <h3 class="black--text">Debtor Name: {{ Debtor.Name }}</h3>
        <h3 class="black--text">
          Due Amount: {{ Debtor.Amount.toLocaleString() }}
        </h3>
        <v-form v-model="valid" class="mt-3" ref="paymentForm">
          <BaseDate
            v-model="PayDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>
          <BaseNumInput
            :rules="[paymentRule]"
            outlined
            v-model.trim="Amount"
            label="Amount"
          ></BaseNumInput>
          <v-text-field
            name="InfoFildName"
            label="Info"
            id="InfoFildid"
            outlined
            v-model.trim="Details"
            :rules="[v => !!v || 'Provide Infomation']"
          ></v-text-field>
          <v-row>
            <v-col>
              <v-radio-group row v-model="cashType">
                <v-radio label="Cash" value="Cash"></v-radio>
                <v-radio label="Mobile" value="Mobile"></v-radio>
                <v-radio label="Bank" value="Main Bank"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="4" v-if="cashType !== 'Cash'">
              <v-text-field
                :rules="[v => !!v || 'Refrance required']"
                solo-inverted
                name="RefBank"
                label="Refrance"
                id="Refid"
                v-model="BankRef"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <p>{{ Amount }}</p> -->
          <!-- <p>{{ Debtor }}</p> -->
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          width="200px"
          :loading="loading"
          @click="OnSavePayment"
          :disabled="!valid"
          color="success"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    Debtor: { type: Object, required: true },
  },
  data() {
    return {
      BaseURL: "/Reports/debtors/payment",
      cashType: "Cash",
      ErrMsg: "",
      BankRef: "",
      loading: false,
      dialog: false,
      valid: false,
      PayDate: "",
      Amount: 0,
      Details: "CASH",
    };
  },
  watch: {
    cashType() {
      this.BankRef = "";
    },
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          // this.PayDate = this.Current().date;
          // this.Amount = this.DueAmount;
          //   this.Amount = 0;
          this.Details = "CASH";
        });
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.cashType = "Cash";
      this.PayDate = "";
      this.Details = "";
      this.Amount = 0;
      this.$refs.paymentForm.resetValidation();
    },
    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.paymentForm.validate()) {
        let data = {
          Description: this.Debtor.Description,
          Amount: this.Amount,
          cashType: this.cashType,
          BankRef: this.BankRef,
          Details: this.Details,
          date: this.PayDate,
          time: this.Current().time,
        };
        this.loading = true;
        this.$store
          .dispatch("INSERT_ONLY", { url: this.BaseURL, data })
          .then(() => {
            // console.log(val);
            this.loading = false;
            this.Debtor.Amount = this.Debtor.Amount - this.Amount;
            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      let andCon =
        v &&
        v.replace(/,/g, "") > 0 &&
        v.replace(/,/g, "") <= this.Debtor.Amount;
      return andCon || "Invalid Amount";
    },
  },
};
</script>
